import { Notifier } from '@airbrake/browser';

const projectId = import.meta.env.VITE_AIRBRAKE_PROJECT_ID;
const projectKey = import.meta.env.VITE_AIRBRAKE_PROJECT_KEY;
const environment = import.meta.env.VITE_ENVIRONMENT_TYPE === 'Production' ? 'Production' :
  `${import.meta.env.VITE_ENVIRONMENT_TYPE}-${import.meta.env.VITE_ENVIRONMENT_SERVER}`;

const getClient = () => {
  if (import.meta.env.DEV || !projectId || !projectKey) {
    return {
      notify: console.log,
    };
  }

  return new Notifier({
    projectId: Number(projectId),
    projectKey,
    environment,
  });
};


export default getClient();
